<template>
        <ion-page>
            <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                <ion-menu-button color="primary"></ion-menu-button>
                </ion-buttons>
                <ion-title>GPS Device Transfer</ion-title>
            </ion-toolbar>
            </ion-header>
            
            <ion-content :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                <ion-title size="large">GPS Device Transfer</ion-title>
                </ion-toolbar>
            </ion-header>
            
            <div id="container">
                <ion-item>
                    <ion-label position="floating">Transfer To <span class="required">*</span></ion-label>
                    <ion-select interface="action-sheet" v-model="user">
                        <ion-select-option v-for="(user,i) of users" :key="i" :value="user.id">{{user.name}} <span v-if="user.distribution_point!=null">({{user.distribution_point.distribution_point_name}})</span> </ion-select-option>
                    </ion-select>
                </ion-item>
                <ion-item>
                    <ion-label position="floating">Transfer Via <span class="required">*</span></ion-label>
                    <ion-select interface="action-sheet" v-model="via">
                        <ion-select-option value="Hand to Hand">Hand to Hand</ion-select-option>
                        <ion-select-option value="Courier">Courier</ion-select-option>
                    </ion-select>
                </ion-item>
                <ion-item>
                        <ion-label position="floating">Remarks</ion-label>
                        <ion-input  v-model="remarks"></ion-input>
                </ion-item>
                <ion-item v-for="(serial,i) of sls" :key="i">
                        <ion-label position="floating">Slot {{i+1}} Serial</ion-label>
                        <ion-input :readonly="true" :value="serial"></ion-input>
                </ion-item>
                <ion-button expand="block" slot="end" @click="submit()">Transfer</ion-button>
            </div>
            </ion-content>
        </ion-page>
</template>

<script >
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar,IonButton,IonSelect,IonSelectOption, IonItem, IonLabel, IonInput, alertController, loadingController } from '@ionic/vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'GPS Device Transfer',
  data(){
      return {
        sls:[],
        users:[],
        user:null,
        via:'',
        remarks:'',
      }
  },
  props:[
      'serials'
  ],
  created(){
      this.sls=JSON.parse(this.serials);
      this.$http.get('getUser',).then(response=>{
      this.users=response.data;
    });
  },
  methods:{
      async presentLoading() {
      const loading = await loadingController
        .create({
          message: 'Loging in.....',
          duration: 60 * 1000,
        });

      await loading.present();
        return loading;
    },
       async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
      async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
       async submit(){
        if(this.user=='' || this.user==null){
            this.presentAlert('Transfer to is required');
            return;
        }
        if(this.via=='' || this.via==null){
            this.presentAlert('Via is required');
            return;
        }
        const data={
            'user_id':this.user,
            via:this.via,
            remarks:this.remarks,
            serial:this.sls,
            username:window.localStorage.username,
            password:window.localStorage.password
        };
        data['username'] = window.localStorage.username,
        data['password'] = window.localStorage.password,
      this.$http.post('transferGpsDevice',data).then(response=>{
        if(response.status==200){
          this.presentResponseAlert('Success','Transfer successfully submitted');
          this.$router.go(-1);
        }
      });      
    }
  },
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    IonItem,
    IonLabel,
    IonInput,
    IonSelect,
    IonSelectOption
  }
});
</script>

<style scoped>

</style>